import React, { useEffect, useState } from 'react';
import { Card, Button, Image, Modal, Form, Offcanvas } from 'react-bootstrap';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import TableHeader from './produitsTableHeader';
import SubtleBadge from 'components/common/SubtleBadge';
// import classNames from 'classnames';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Dropdown } from 'react-bootstrap';
// import CardDropdown from 'components/common/CardDropdown';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaRegFileLines } from 'react-icons/fa6';
import { RiFileEditLine } from 'react-icons/ri';
import { FiArchive } from 'react-icons/fi';
import { getProduits, updateConventionProduits } from 'data/produits';
import { updateProduit } from 'data/produits';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import ProduitsFilteringForm from './ProduitsFilteringForm';

const EditProductModal = ({ show, handleClose, product, handleSave }) => {
  const [formData, setFormData] = useState({
    produit: product?.produit?.produit || '',
    barcode: product?.barcode || '',
    remmax: product?.remmax || 0,
    remMaxConvention: product?.remMaxConvention || 0,
    punitttc: product?.punitttc || 0,
    actif: product?.actif || true,
  });

  useEffect(() => {
    if (show) {
      setFormData({
        produit: product?.produit?.produit || '',
        barcode: product?.barcode || '',
        remmax: product?.remmax || 0,
        remMaxConvention: product?.remMaxConvention || 0,
        punitttc: product?.punitttc || 0,
        actif: product?.actif || true,
      });
    }
  }, [show]);

  useEffect(() => {
    if (product) {
      setFormData({
        produit: product?.produit?.produit || '',
        barcode: product?.barcode || '',
        remmax: product?.remmax || 0,
        remMaxConvention: product?.remMaxConvention || 0,
        punitttc: product?.punitttc || 0,
        actif: product?.actif || true,
      });
    }
  }, [product]);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const result = await Swal.fire({
      title: 'Êtes-vous sûr?',
      text: 'Voulez-vous vraiment modifier ce(s) produit(s)?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2c7be5',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, modifier!',
      cancelButtonText: 'Annuler',
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      handleSave(formData);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Modifier attributs</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3 d-flex">
            <Form.Label className="w-50">remise max</Form.Label>
            <Form.Control
              type="number"
              name="remmax"
              value={formData.remmax}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3 d-flex">
            <Form.Label className="w-50">remise max convention</Form.Label>
            <Form.Control
              type="number"
              name="remMaxConvention"
              value={formData.remMaxConvention}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3 d-flex">
            <Form.Label className="w-25">Secteur</Form.Label>
            <Form.Control
              type="text"
              name="secteur"
              value={formData.secteur}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3 d-flex">
            <Form.Label className="w-25">Categorie</Form.Label>
            <Form.Control
              type="text"
              name="categorie"
              value={formData.categorie}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3 d-flex align-items-center gap-2">
            <Form.Label className="w-25">Famille</Form.Label>
            <Form.Control
              type="text"
              name="famille"
              value={formData.famille}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3 d-flex align-items-center gap-2">
            <Form.Label className="w-25">Stock Min</Form.Label>
            <Form.Control
              type="number"
              name="stockMin"
              value={formData.stockMin}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Check
            type="switch"
            id="custom-switch"
            label="Produit actif"
            name="actif"
            checked={formData.actif}
            onChange={handleChange}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Annuler
          </Button>
          <Button variant="primary" type="submit">
            Enregistrer
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

const ProduitsTable = ({ secteur, categorie, famille }) => {
  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [filterState, setFilterState] = useState({});
  const [remiseConvention, setRemiseConvention] = useState(0);

  const handleFilterUpdate = newFilterState => {
    setFilterState(newFilterState);
    // Add any additional filtering logic here if needed
  };

  const columns = [
    {
      accessorKey: 'id',
      header: 'id',
      meta: {
        headerProps: { className: 'pe-1 white-space-nowrap text-900' },
        cellProps: { className: 'font-sans-serif white-space-nowrap' },
      },
      cell: ({ row: { original } }) => {
        const { id } = original;
        return (
          <p
            className="mb-0"
            style={{ color: selectedRows.some(row => row.id === id) ? 'red' : 'black' }}
          >
            {id}
          </p>
        );
      },
    },
    {
      accessorKey: 'produit',
      header: 'Produit',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-2 text-end w-5 text-primary fw-semibold',
        },
      },
      //"xs" | "lg" | "sm" | "1x" | "2x" | "3x" | "4x" | "5x" | "6x" | "7x" | "8x" | "9x" | "10x"
      cell: ({ row: { original } }) => {
        const { produit, barcode, code, aepromo, rempromo, actif } = original;

        return (
          <div className="d-flex">
            <div className="d-flex position-relative">
              <Image
                src={'https://imagesproduits.lebosphore.tn/' + code + '.webp'}
                alt={produit.produit}
                loading="lazy"
                className="card-img-top"
                style={{
                  width: '50px',
                  height: '50px',
                }}
                // onError={e => {
                //   e.target.src = defaultImage;
                // }}
              />
              {aepromo == '1' && (
                <span
                  className="text-start"
                  style={{
                    fontSize: '11px',
                    marginBottom: 0,
                    backgroundColor: 'red',
                    color: 'white',
                    padding: '2px 5px',
                    borderRadius: '5px',
                    height: '20px',
                    width: '35px',
                    position: 'absolute',
                    top: '0',
                    right: '0',
                    opacity: '0.8',
                  }}
                >
                  {parseFloat(rempromo)?.toFixed(0)}%
                </span>
              )}
            </div>
            <div className="ms-3">
              <div className="d-flex gap-1">
                {produit && (
                  <h6
                    className="text-start "
                    style={{
                      marginBottom: 0,
                      fontSize: '15px',
                      color: actif ? 'rgb(44, 123, 229)' : 'gray',
                    }}
                  >
                    {produit}
                  </h6>
                )}
              </div>

              {barcode && (
                <p className="text-start text-secondary" style={{ marginBottom: 0 }}>
                  {barcode}
                </p>
              )}
            </div>
          </div>
        );
      },
    },
    {
      accessorKey: 'remmax',
      header: 'remise max',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'text-start w-1 text-primary fw-semibold',
          style: { fontSize: '12px' },
        },
      },
      cell: ({ row: { original } }) => {
        const { remmax } = original;
        return (
          <>
            {remmax && (
              <>
                <div className="text-center">
                  <span
                    // className="fs-9"
                    style={{ marginBottom: 0, textAlign: 'center', fontSize: '14px' }}
                  >
                    {`${remmax}`}%
                  </span>
                </div>
              </>
            )}
          </>
        );
      },
    },
    {
      accessorKey: 'remMaxConvention',
      header: 'remise max convention',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'text-start w-1 text-primary fw-semibold',
          style: { fontSize: '12px' },
        },
      },
      cell: ({ row: { original } }) => {
        const { remMaxConvention } = original;
        return (
          <>
            {remMaxConvention && (
              <>
                <div className="text-center">
                  <span
                    // className="fs-9"
                    style={{
                      marginBottom: 0,
                      textAlign: 'center',
                      fontSize: '14px',
                      backgroundColor: 'green',
                      color: 'white',
                      padding: '2px 5px',
                      borderRadius: '5px',
                      height: '20px',
                      width: '35px',
                    }}
                  >
                    {`${remMaxConvention}`}%
                  </span>
                </div>
              </>
            )}
          </>
        );
      },
    },
    {
      accessorKey: 'secteur',
      header: 'secteur',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-5 text-start w-1 text-primary fw-semibold',
        },
      },
    },
    {
      accessorKey: 'categorie',
      header: 'categorie',
      meta: {
        headerProps: { className: 'text-start text-900 ', style: { maxWidth: '150px' } },
        cellProps: {
          className: 'ps-5 text-start w-1 text-primary fw-semibold',
          style: { maxWidth: '150px' },
        },
      },
    },
    {
      accessorKey: 'famille',
      header: 'famille',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-5 text-start w-1 text-primary fw-semibold',
        },
      },
    },
    {
      accessorKey: 'TVA',
      header: 'TVA',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-2 text-start w-5 text-primary fw-semibold',
        },
      },
      cell: ({ row: { original } }) => {
        const { tva } = original;
        return (
          <div className="text-center">
            <SubtleBadge
              bg="secondary"
              className="px-2 py-1" // Add padding for better appearance
              style={{ display: 'inline-block' }} // Ensure it takes only the space of the content
            >
              <p className="mb-0 fs-10">{`${tva}%`}</p>
            </SubtleBadge>
          </div>
        );
      },
    },
    {
      accessorKey: 'punitttc',
      header: 'PunitTTC',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-5 text-start w-1 text-primary fw-semibold',
        },
      },
    },
    {
      accessorKey: 'tva',
      header: 'TVA',
      meta: {
        headerProps: { className: 'text-start text-900 ', style: { maxWidth: '100px' } },
        cellProps: {
          className: 'ps-5 text-start w-1  fw-semibold',
        },
      },
    },
    {
      accessorKey: 'stockmin',
      header: 'StockMin',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-5 text-start w-1 fw-semibold',
        },
      },
    },
    {
      accessorKey: 'ACTIONS',
      header: 'ACTIONS',
      meta: {
        headerProps: {
          className: 'text-center text-900',
        },
        cellProps: {
          className: 'fs-9',
        },
      },
      cell: ({ row: { original } }) => {
        // const [isHovered, setIsHovered] = useState(false);
        const { id } = original;
        // const navigate = useNavigate();
        return (
          <div className="text-end d-flex">
            <OverlayTrigger
              overlay={
                <Tooltip
                  style={{ position: 'fixed' }} // Apply the custom style
                  className="custom-tooltip" // Apply the custom class
                  id="overlay-trigger-example"
                >
                  Consulter Produit
                </Tooltip>
              }
            >
              <Button
                variant="link"
                className="p-0"
                // onClick={() => {
                //   navigate(`/dashboard/produitsServices/${id}`);
                // }}
              >
                <FaRegFileLines />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger
              overlay={
                <Tooltip
                  style={{ position: 'fixed' }} // Apply the custom style
                  className="custom-tooltip" // Apply the custom class
                  id="overlay-trigger-example"
                >
                  Editer Produit
                </Tooltip>
              }
            >
              <Button variant="link" className="p-0 mx-3">
                <RiFileEditLine />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger
              overlay={
                <Tooltip
                  style={{ position: 'fixed' }} // Apply the custom style
                  className="custom-tooltip" // Apply the custom class
                  id="overlay-trigger-example"
                >
                  Archiver Produit
                </Tooltip>
              }
            >
              <Button variant="link" className="p-0">
                <FiArchive />
              </Button>
            </OverlayTrigger>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    fetchProduits();
  }, []);
  const fetchProduits = async () => {
    try {
      setLoading(true);
      const response = await getProduits(filterState);
      console.log(response);
      setData(response);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching produits:', error);
    }
  };
  const mettreAJourRemiseConvention = async () => {
    try {
      setLoading(true);
      const codes = selectedRows.map(row => row.code);
      const chunkSize = 250;
      const responses = [];

      // Process in chunks of 250 items
      for (let i = 0; i < codes.length; i += chunkSize) {
        const chunk = codes.slice(i, i + chunkSize);
        const response = await updateConventionProduits(chunk, remiseConvention);
        responses.push(response);
      }

      console.log('All responses:', responses);
      toast.success('Produits modifiés avec succès!', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setShowEditModal(false);
      setLoading(false);
      setData(
        data.map(row => {
          if (selectedRows.map(row => row.code).includes(row.code)) {
            return { ...row, remMaxConvention: remiseConvention };
          }
          return row;
        })
      );

      // await fetchProduits({
      //   secteur: filterState.secteur,
      //   categorie: filterState.categorie,
      //   famille: filterState.famille,
      // });
      // toast.success('Produit modifié avec succès');
    } catch (error) {
      console.error('Error updating produit:', error);
    }
  };
  const table = useAdvanceTable({
    data: data,
    columns: columns,
    selection: true,
    sortable: true,
    pagination: true,
    perPage: 100,
    selectionColumnWidth: 52,
  });

  useEffect(() => {
    const selectedRows = table.getSelectedRowModel().rows.map(row => row.original);
    setSelectedRows(selectedRows);
    console.log(selectedRows);
  }, [table.getSelectedRowModel().rows]);

  const handleSaveProduct = async product => {
    try {
      setLoading(true);
      console.log('selectedProducts 1111', selectedRows);
      console.log('product1111', product);
      const response = await updateProduit(selectedRows, product);
      console.log(response);
      toast.success('Produits modifiés avec succès!', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setShowEditModal(false);
      setLoading(false);
      await fetchProduits({
        secteur: filterState.secteur,
        categorie: filterState.categorie,
        famille: filterState.famille,
      });
      // toast.success('Produit modifié avec succès');
    } catch (error) {
      console.error('Error updating produit:', error);
    }
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={() => setShow(false)}
        placement="end"
        className="dark__bg-card-dark"
      >
        <Offcanvas.Header closeButton className="bg-body-tertiary">
          <h6 className="fs-9 mb-0 fw-semibold">Filter</h6>
        </Offcanvas.Header>
        <ProduitsFilteringForm
          setShow={setShow}
          onFilterUpdate={handleFilterUpdate}
          filterState={filterState}
          fetchEntetes={fetchProduits}
          // entetesLoading={entetesLoading}
          setFilterState={setFilterState}
          secteur={secteur}
          categorie={categorie}
          famille={famille}
        />
      </Offcanvas>
      <AdvanceTableProvider {...table}>
        <Card>
          <Card.Header className="px-0 d-flex justify-content-between">
            <TableHeader
              selectedProduct={selectedProduct}
              setShowEditModal={setShowEditModal}
              loading={loading}
              setShow={setShow}
              // handleShow={handleShow}
              // handleDetailsUpdate={handleDetailsUpdate}
              // setTypeLignes={setTypeLignes}
            />
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Form.Control
                type="number"
                placeholder="Search"
                className="form-control form-control-sm"
                style={{ width: '100px' }}
                value={remiseConvention}
                onChange={e => setRemiseConvention(e.target.value)}
              />
              <Button
                variant="falcon-default"
                size="sm"
                transform="shrink-4"
                className="mx-2"
                onClick={mettreAJourRemiseConvention}
              >
                Appliquer
              </Button>
            </div>
          </Card.Header>
          <Card.Body className="p-0" style={{ height: '500px', overflowY: 'auto' }}>
            <AdvanceTable
              headerClassName="bg-body-tertiary align-middle"
              rowClassName="btn-reveal-trigger align-middle"
              tableProps={{
                size: 'sm',
                className: 'fs-10 mb-0 overflow-hidden',
              }}
              // onRowClick={row => handleLignes(row)}
              fixedHeader={true}
              onRowSelectionChange={setSelectedRows}
            />
          </Card.Body>
          <Card.Footer>
            <AdvanceTableFooter
              rowInfo
              perPage
              navButtons
              rowsPerPageSelection={[20, 50, 100, 200, 500, 1000]}
            />
          </Card.Footer>
        </Card>
      </AdvanceTableProvider>
      <EditProductModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        product={selectedProduct}
        handleSave={handleSaveProduct}
      />
    </>
  );
};

export default ProduitsTable;
